'use strict';

const colors = {
    "default": "black",
    "primary": "var(--base-color)",
}

const actionHrefs = {
    "get-price": "#get-price",
}

const styleMap = {
    "bold": { fontWeight: "700" },
    "italic": { fontStyle: "italic" },
}

export default function HighlightedText({ text, highlights, multiline = false, lineBreak = 'br' }) {
    const parts = []
    let lastIndex = 0

    highlights.forEach(({ word, ...opt }) => {
        const index = text.indexOf(word, lastIndex)

        if (index !== -1) {
            if (index > lastIndex) {
                parts.push(text.slice(lastIndex, index))
            }
            const href = opt.href || (opt.action && actionHrefs[opt.action])
            const baseStyle = {
                ...(opt.color && opt.color !== 'default' ? { color: colors[opt.color] } : {}),
                ...resolveStyle(opt.style),
            }
            const hasStyle = Object.keys(baseStyle).length > 0
            if (href) {
                parts.push(<a href={href} key={index} style={hasStyle ? baseStyle : undefined}>{word}</a>)
            } else if (opt.onPress) {
                parts.push(<a role="button" onClick={() => opt.onPress()} key={index} style={hasStyle ? baseStyle : undefined}>{word}</a>)
            } else {
                parts.push(hasStyle ? <span style={baseStyle} key={index}>{word}</span> : word)
            }
            lastIndex = index + word.length
        }
    })

    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex))
    }

    if (multiline) {
        const finalParts = parts.flatMap((p, i) =>
            typeof p === 'string' ? splitWithLineBreaks(p, `part-${i}`, lineBreak) : p
        )
        return <>{finalParts}</>
    }

    return <>{parts}</>
}

export function renderRichText(richText) {
    if (Array.isArray(richText))
        return richText.map(renderTextPart)

    return renderTextPart(richText)
}

function renderTextPart(part) {
    if (typeof part === 'string')
        return part

    return <HighlightedText text={part.text} highlights={part.highlights} />
}

function resolveStyle(s) {
    if (!s) return {}
    const arr = Array.isArray(s) ? s : [s]
    return Object.assign({}, ...arr.map(v => styleMap[v]))
}

function splitWithLineBreaks(value, keyPrefix, lineBreak) {
    if (!value.match(/\\n|\n/)) return [value]
    if (lineBreak === 'space') return [value.split(/\\n|\n/).join(' ')]
    return value.split(/\\n|\n/).flatMap((line, i) =>
        i === 0 ? [line] : [<br key={`${keyPrefix}-br-${i}`} />, line]
    )
}
